const data = {
  mainRoutes: [
    {
      label: "TV",
      route: " ",
      subdomain: "tv",
      id: "tv"
    },
    {
      label: "MAGAZINE",
      route: "/magazine",
      id: "magazine"
    },
    {
      label: "LOGIN",
      route: " ",
      subdomain: "login",
      id: "login"
    }
  ],
  buttonRoutes: [
    {
      id: "gtb",
      label: "Get The Box",
      route: "/get-the-box/?step=getbox#plan=fffvip"
    }
  ]
};

export default data;
